import { useEffect, useState } from "react";
import { MAX_QUANTIDADE_DO_SERVICO } from "@bookdental/schemas";
import { origemDasUnidades } from "@/components/prosthesis/valor-do-pedido";

/**
 * Unidades do serviço no Editar serviço. O número segue a regra do serviço (1 por dente, ou 1 no
 * serviço de arcada) e acompanha os dentes; digitar fica atrás de "Ajustar", pra exceção (pôntico, peça a
 * mais) — um campo numérico solto ao lado dos dentes fazia parecer que era pra preencher sempre.
 */
export function CampoDeUnidades({
  valor,
  dentes,
  abrangencia,
  ajustada,
  onMudar,
}: {
  valor: number;
  dentes: string | null;
  abrangencia?: string;
  /** A pessoa digitou neste diálogo. */
  ajustada: boolean;
  /** Número digitado, ou nulo pra voltar a seguir a regra. */
  onMudar: (n: number | null) => void;
}) {
  const [editando, setEditando] = useState(ajustada);
  useEffect(() => setEditando(ajustada), [ajustada]);
  const origem = origemDasUnidades({ teeth: dentes, quantidade: valor, abrangencia });

  if (!editando) {
    return (
      <p className="text-[13px] text-zinc-900 dark:text-foreground">
        <span className="font-medium tabular-nums">{valor}</span> {valor === 1 ? "unidade" : "unidades"}
        {origem && <span className="text-zinc-500 dark:text-muted-foreground"> · {origem}</span>}
        <button
          type="button"
          onClick={() => setEditando(true)}
          className="ml-2 text-[12px] font-semibold text-brand-700 hover:underline dark:text-primary"
        >
          Ajustar
        </button>
      </p>
    );
  }

  return (
    <div className="space-y-1">
      <div className="flex items-center gap-2">
        <input
          type="number"
          min={1}
          max={MAX_QUANTIDADE_DO_SERVICO}
          value={valor}
          autoFocus
          onChange={(e) => onMudar(Math.min(Math.max(Number(e.target.value) || 1, 1), MAX_QUANTIDADE_DO_SERVICO))}
          aria-label="Unidades"
          className="h-9 w-20 rounded-md border border-zinc-200 bg-white px-2.5 text-sm tabular-nums text-zinc-900 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 dark:border-border dark:bg-card dark:text-foreground"
        />
        <button
          type="button"
          onClick={() => {
            onMudar(null);
            setEditando(false);
          }}
          className="text-[12px] font-semibold text-zinc-600 hover:underline dark:text-muted-foreground"
        >
          Voltar ao automático
        </button>
      </div>
      <p className="text-[11px] text-zinc-500 dark:text-muted-foreground">
        Só quando a cobrança não segue a regra (ex.: pôntico de ponte, placa superior e inferior cobradas separadas). O valor do serviço é preço × unidades.
      </p>
    </div>
  );
}
